var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse2839(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 2171,
    transform: "translate(-247 -440)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -247,
    y: -186,
    width: 1365,
    height: 1363,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -139,
    y: -34,
    width: 1150,
    height: 1108,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -118,
    y: -11,
    width: 160,
    height: 160,
    rx: 12,
    fill: "white",
    stroke: "#8F96A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#097E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9536 23.8131H23.9998",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1483 9.65501C17.466 9.28792 17.9124 9.05675 18.3955 9.00914C18.8787 8.96153 19.3617 9.1011 19.7449 9.39911C19.7906 9.43174 19.8319 9.46993 19.8681 9.51283L21.1854 10.5458C21.3915 10.672 21.5707 10.8376 21.7127 11.0331C21.8548 11.2286 21.9569 11.4502 22.0132 11.6852C22.0696 11.9202 22.079 12.1641 22.0411 12.4027C22.0031 12.6414 21.9184 12.8702 21.7919 13.0761L21.6971 13.2183L13.8409 23.2353C13.7128 23.403 13.5479 23.5389 13.3589 23.6325C13.17 23.7262 12.9619 23.7751 12.751 23.7755H9.71842L9.03609 20.8282C8.98933 20.6225 8.98799 20.4091 9.03219 20.2029C9.07638 19.9967 9.16502 19.8025 9.29195 19.6341L17.1483 9.65501Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6794 11.5311L20.2283 15.0944",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 2171,
    fill: "white",
    transform: "translate(-247 -440)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse2839);
export default __webpack_public_path__ + "static/media/Ellipse 2839.2744423740381a53f4116f400634516c.svg";
export { ForwardRef as ReactComponent };